<template>
  <div id="select-dropdown">
    <b-dropdown v-bind:text="$t((prefix != '' ? prefix + '.' : '') + (value.label != null ? value.label : value.name))" v-bind:variant="theme" v-bind:slot="this.position">
      <b-dropdown-item v-for="item in values" :key="item.id" @click="setSelected(item)" v-if="checkShowByConfig(item.name)">
        {{$t((prefix != '' ? prefix + '.' : '') + (item.label != null ? item.label : item.name))}}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script>
export default {
  name: 'SelectDropdown',
  props: {
    options: {
      type: Array,
      required: true
    },
    selected: {
      type: String,
      required: false
    },
    position: {
      type: String,
      required: false
    },
    theme: {
      type: String,
      required: false,
      default: 'secondary'
    },
    all: {
      type: Boolean,
      required: false,
      default: false
    },
    prefix: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function () {
    return {
      value: this.selected,
      values: this.options
    }
  },
  methods: {
    checkShowByConfig (key) {
      let obj = this.$store.getters.config.gms[this.prefix]
      if (obj == null) {
        return true
      }
      let config = this._.find(obj.basic_info, function (o) {
        return o.type === key
      })
      if (config == null) {
        return true
      }
      return config.show
    },
    setSelected: function (val) {
      this.value = val
      if (this.value.name == 'all') {
        this.$emit('input', null)
      } else {
        this.$emit('input', this.value.name)
      }
    }
  },
  created () {
    if (this.all) {
      let newOptions = [{name: 'all'}]
      for (let i in this.options) {
        newOptions.push(this.options[i])
      }
      this.values = newOptions
    }
    if (this.selected == null && this.values.length > 0) {
      this.value = this.values[0]
      for (let i in this.values) {
        if (this.values[i]['default']) {
          this.value = this.values[i]
        }
      }
    } else if (this.selected && this.values.length > 0) {
      for (let i in this.values) {
        if (this.values[i]['name'] === this.selected) {
          this.value = this.values[i]
        }
      }
    }
    if (this.position == null) {
      this.position = 'prepend'
    }
    if (this.value == 'all') {
      this.$emit('input', null)
    } else {
      this.$emit('input', this.value.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Partials/SelectDropdown.vue